import clsx from 'clsx';
import React from 'react';
import './POSLoadingOverlay.less';

export interface POSLoadingOverlayProps {
  children: React.ReactNode;
  loading: boolean;
  className?: string;
  inverted?: boolean;
}

export const POSLoadingOverlay: React.VFC<POSLoadingOverlayProps> = ({
  loading,
  children,
  className,
  inverted,
}) => {
  return (
    <div
      className={clsx(
        className,
        'pos-loading-overlay',
        { active: loading },
        {
          inverted: inverted,
        }
      )}
    >
      {children}
    </div>
  );
};
